/**
 * Converts a raw string from a numeric input into a number for storing in
 * react-hook-form state. Returns an empty string (not undefined) when the
 * input is empty, since react-hook-form falls back to a field's initial
 * default value whenever a controlled value is set to undefined.
 * @param value - Raw string value from the input's onChange.
 * @returns The parsed number, or '' if the input is empty or not a valid number.
 */
export const parseNumericInput = (value: string): number | string => {
  if (value === '') return '';
  const numValue = Number(value);
  return isNaN(numValue) ? '' : numValue;
};
